/**
 * @module lineheight/lineheightediting
 */

import LineEditing from '../lineediting';

/**
 * The paragraphspacing editing feature. It introduces the {@link ParagraphSpacingCommand command} and adds
 * the `paragraphspacing` attribute for block elements in the {@link Model model}.
 *
 * @extends LineEditing
 */
export default class ParagraphSpacingEditing extends LineEditing {

	/**
	 * @inheritDoc
	 */
	static get pluginName() {
		return 'ParagraphSpacingEditing';
	}

	/**
	 * @inheritDoc
	 */
	constructor( editor ) {
		super( editor, 'paragraphspacing', 'normal', [ 'margin-top', 'margin-bottom' ], [ 'normal', '0', '6pt', '12pt', '18pt' ] );
	}
}
